import React, { FC, useCallback } from 'react'
import { Layout } from 'components/Layout'
import { CompleteTemplate } from 'components/Templates'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const SettingsComplete: FC = () => {
  const dispatch = useDispatch()
  const backToTop = useCallback(() => dispatch(push('/')), [dispatch])

  return (
    <Layout title={'完了 | 営業時間・定休日の修正'}>
      <CompleteTemplate
        iconPath={'/icon/done/notice.svg'}
        label={'営業時間と定休日の修正が\n完了しました。'}
        backToTop={backToTop}
      />
    </Layout>
  )
}

export default SettingsComplete
